import React, { useRef } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { MeNumberIcon } from "../../../../components/icon";
import { useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useEffect } from "react";
import { useState } from "react";
import { fetchUnpaidOrderCount, fetchMessageToObject } from "../../../../../../../api";
import Cache from "../../../../../../../utils/cache";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

const PointsMessage = props =>{
    const { couponMsg } = props;
    const [message, setMessage] = useState(null);

    useEffect(async () =>{
        let indexPoint = Cache.get("index_points_message");
        let couponsMessageCache = Cache.get("me_coupons_message");
        if((!couponMsg || couponsMessageCache) && !indexPoint){
            let response = await fetchMessageToObject("M1578");
            if(response?.code === 200 && response?.result){
                setMessage(response.result);
                Cache.set("index_points_message",true);
                setTimeout(() => {
                    setMessage(null);
                },3000);
            }
        }
    }, [couponMsg]);

    return <React.Fragment>
        {
            message?.me?.message && <div className={cls.PointsMessage}>
                <span dangerouslySetInnerHTML={{__html: message.me.message}}></span>
            </div>
        }
    </React.Fragment>
}

const CouponsMessage = props =>{
    const { couponMsg } = props;
    const [show, setShow] = useState(false);
    const timmer = useRef()

    useEffect(() =>{
        let couponsMessageCache = Cache.get("me_coupons_message");
        if(!couponsMessageCache && couponMsg){
            setShow(true);
            timmer.current = setTimeout(() => {
                Cache.set("me_coupons_message", true);
                setShow(false);
            }, 3000);
        }

        return () =>{
            clearTimeout(timmer.current)
        }
    }, []);

    return <React.Fragment> 
        {
            show && <div className={cls.CouponsMessage}>
                <div className={cls.CouponsFont}>
                    <span dangerouslySetInnerHTML={{ __html: couponMsg }}></span>
                </div>
                
                <div className={cls.CouponsIcon}>
                    <Iconfont onClick={() =>{
                        clearTimeout(timmer.current);
                        Cache.set("me_coupons_message", true);
                        setShow(false);
                    }}>&#xe7c9;</Iconfont>
                </div>
            </div>
        }
    </React.Fragment>
}

const ServiceUnit = (props) =>{
    const { title, handleClick } = props;

    return <div className={`${cls.ServiceUnitContainer} ${props?.className ? props.className : ""}`}>
        {
            title && <div className={cls.HeaderContainer}>
                <div className={cls.Title}>
                    {title}
                </div>

                {
                    !!handleClick && <div className={cls.ViewMore} onClick={handleClick}>
                        <FormattedMessage id="view_all" defaultMessage="View All" /> {'>'}
                    </div>
                }
            </div>
        }

        <div className={`${cls.ServiceUnit} ${title ? cls.PaddingTop0 : ""}`}>
            {props?.children}
        </div>
    </div>
}

export default props =>{
    useStyles(cls);
    const { feed, isLogin, isVipUser, customer, checkoutLoginStatus, showNewIcon } = props;
    const [unpiadOrderCount, setUnpaidOrderCount] = useState(0);
    const Intl = useIntl();
    const global = useSelector(state =>state.global);
    const { config } = global;

    useEffect(async () =>{
        try {
            let response = await fetchUnpaidOrderCount();
            if(response?.code === 200 && response?.result){
                setUnpaidOrderCount(response.result);
            }
        } catch (error) {
            console.log('error', error)
        }
    },[]);

    const getFeedNum = useCallback((value) =>{
        return isLogin && value > 0 ? value : 0;
    }, [isLogin])

    const checkoutLoginHandle = useCallback((evt, path, difference) =>{
        evt.preventDefault();
        checkoutLoginStatus(path, difference);
    }, [customer]);

    return <div className={cls.UserService}>
        <ServiceUnit className={`${!isVipUser?cls.NoVipClass:""}`}>
            <MeNumberIcon 
                to="/user/coupons" 
                icon="&#xe6dc;" 
                count={getFeedNum(feed?.canUseCouponCount)} 
                title={Intl.formatMessage({ id: "coupons", defaultMessage: "Coupons" })} 
                handleClick={checkoutLoginHandle} 
            />
            
            <a className={`${cls.MeNumberIcon}`} onClick={(evt) =>checkoutLoginHandle(evt, '/user/credits' , 1)}>
                {
                    !!getFeedNum(feed?.points) ? <React.Fragment>
                        <div className={cls.PointsIcon}>
                            <img className={cls.AnimationPointsIcon} src={`https://image.geeko.ltd/2021-11-01-lottery/2021-11-01-lottery-points.png`} alt="" />
                            <span className={cls.AnimationPointsTextFont}>{getFeedNum(feed?.points)}</span>
                        </div>
                    </React.Fragment> : <React.Fragment>
                        <div className={cls.IconOrFont}>
                            <Iconfont className={`${cls.Icon}`}>&#xe6db;</Iconfont>
                        </div>
                    </React.Fragment>
                }
                
                <div className={cls.Title}>
                    <FormattedMessage id="points" defaultMessage="Points" />
                </div>
            </a>

            <MeNumberIcon 
                to="/user/wallet" 
                icon="&#xe6dd;" 
                title={Intl.formatMessage({ id: "wallet", defaultMessage: "Wallet" })} 
                handleClick={checkoutLoginHandle} 
            />

            {
                isVipUser && <MeNumberIcon to={`/user/vip`} icon="&#xe783;" title="VIP" themeColor={"#DDC35E"} new={showNewIcon} handleClick={checkoutLoginHandle} />
            }
            
            {
                !!feed && <React.Fragment>
                    <PointsMessage couponMsg={feed.couponMsg} />

                    {
                        feed.couponMsg && <CouponsMessage couponMsg={feed.couponMsg} />
                    }
                </React.Fragment>
            }
        </ServiceUnit>

        <ServiceUnit className={cls.MarginTop20} title={Intl.formatMessage({ id: "my_order", defaultMessage: "My Order" })} handleClick={() =>{checkoutLoginStatus('/user/order/all', 1);}}>
            <MeNumberIcon to={`/user/order/unpaid`} icon="&#xe6df;" title={Intl.formatMessage({ id: "unpaid", defaultMessage: "Unpaid" })} number={unpiadOrderCount} handleClick={checkoutLoginHandle} />
            <MeNumberIcon to={`/user/order/processing`} icon="&#xe6e0;" title={Intl.formatMessage({ id: "processing", defaultMessage: "Processing" })} number={getFeedNum(feed?.awaitingDeliveryCount)} handleClick={checkoutLoginHandle} />
            <MeNumberIcon to={`/user/order/shipped`} icon="&#xe6e4;" title={Intl.formatMessage({ id: "shipped", defaultMessage: "Shipped" })} number={getFeedNum(feed?.orderShippedCount)} handleClick={checkoutLoginHandle} />
            <MeNumberIcon to={`/user/order/confirmed`} icon="&#xe6de;" title={Intl.formatMessage({ id: "review", defaultMessage: "Review" })} number={getFeedNum(feed?.orderAwaitingReviewCount)} handleClick={checkoutLoginHandle} />
        </ServiceUnit>

        <ServiceUnit className={cls.MarginTop20} title={Intl.formatMessage({ id: "my_services", defaultMessage: "My Service" })}>
            <MeNumberIcon to={'/user/support'} icon="&#xe6e1;" title={Intl.formatMessage({ id: "support", defaultMessage: "Support" })} handleClick={checkoutLoginHandle} />
            <MeNumberIcon to={`/user/survey`} icon="&#xe6e2;" title={Intl.formatMessage({ id: "survey", defaultMessage: "Survey" })} handleClick={checkoutLoginHandle} />
            <MeNumberIcon to={`/user/suggestion`} icon="&#xe6e5;" title={Intl.formatMessage({ id: "suggestion", defaultMessage: "Suggestion" })} handleClick={checkoutLoginHandle} />
            <MeNumberIcon to={`/user/share`} icon="&#xe6da;" title={Intl.formatMessage({ id: "refer_a_friend", defaultMessage: "Refer a Friend" })} handleClick={checkoutLoginHandle} />
        
            {
                config?.showClog && <MeNumberIcon href={`/v-shop`} icon="&#xe787;" title={"V-Shop"} handleClick={()=>{}} className={cls.IconSize24} />
            }
        </ServiceUnit>
    </div>
}